import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import store from './redux/store';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import { PostHogProvider } from 'posthog-js/react';

const rootElement = document.getElementById('root');

// Check if the root element exists before attempting to render
if (rootElement) {
  // Instead of ReactDOM.render, use createRoot
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <PostHogProvider
        apiKey={process.env.REACT_APP_POSTHOG_KEY}
        options={{
          api_host: process.env.REACT_APP_POSTHOG_HOST,
          capture_exceptions: true, // Enable capturing exceptions using Error Tracking
          debug: process.env.NODE_ENV === 'development',
        }}
      >
        <Toaster />
        <Provider store={store}>
          <App />
        </Provider>
      </PostHogProvider>
    </React.StrictMode>
  );
}